import React, {useState, useEffect} from 'react'
import SettingShippingRuleFilters from "./SettingShippingRuleFilters"
import SettingShippingRuleTable from "./SettingShippingRuleTable"
import SettingShippingRuleProvider from "./SettingShippingRuleProvider"
import UseDebounce from "../helpers/UseDebounce";
import {getPlatform, getShippingRules} from "../../../services/api/apiSettingShippingRule"
import {Link} from "react-router-dom"

const SettingShippingRulePage = () => {
    const [platforms, _setPlatforms] = useState([])
    const [page, _setPage] = useState(1)
    const [limit, _setLimit] = useState(50)
    const [loading, _setLoading] = useState(true)
    const [total, _setTotal] = useState(0)
    const [error, _setError] = useState('')
    const [shippingRuleLists, _setShippingRuleLists] = useState([])
    const [filters, _setFilters] = useState({})

    const debouncedSearchSku = filters.sku === '' ? UseDebounce(filters.type, 0) : UseDebounce(filters.type, 500)
    const debouncedSearchCountry = filters.country === '' ? UseDebounce(filters.country, 0) : UseDebounce(filters.country, 500)
    const debouncedSearchState = filters.state === '' ? UseDebounce(filters.state, 0) : UseDebounce(filters.state, 500)
    const debouncedSearchStore = filters.store === '' ? UseDebounce(filters.store, 0) : UseDebounce(filters.store, 500)
    const debouncedSearchTag = filters.tag === '' ? UseDebounce(filters.tag, 0) : UseDebounce(filters.tag, 500)

    const _hadleSetState = (filters) => {
        _setFilters(filters)
        _setPage(1)
    }

    const _fetchListPlatforms = async () => {
        try {
            const {data, success} = await getPlatform()

            if (!success) {
                return
            }

            const formatPlatforms = data.map(platform => {
                return {
                    value: platform._id,
                    name: platform.name,
                }
            })

            _setPlatforms(formatPlatforms)
        } catch (e) {

        }
    }

    const _fetchListShippingRule = async () => {
        try {
            _setLoading(true)
            _setError('')

            const payload = {
                query: filters,
                pagination: {
                    limit,
                    page: page
                }
            }
            
            const {data, success, message} = await getShippingRules(payload)

            if (!success) {
                _setLoading(false)
                _setShippingRuleLists([])
                return _setError(message)
            }

            const {rows, total} = data

            _setShippingRuleLists(rows)

            _setLoading(false)
            _setError('')
            _setTotal(total)
        } catch (e) {
            _setLoading(false)
            _setError(e.message)
        }
    }

    const _handleSetPage = (page) => {
        _setPage(page)
    }

    const _handleSetSize = (size) => {
        _setLimit(size)
    }

    useEffect(() => {
        _fetchListPlatforms()
    }, [])

    useEffect(() => {
        _fetchListShippingRule()
    }, [debouncedSearchSku, debouncedSearchCountry, debouncedSearchState, debouncedSearchStore, debouncedSearchTag, filters.platform, filters.shipping_carrier, filters.status, limit, page]) // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <SettingShippingRuleProvider filters={filters} setState={_hadleSetState} loadShippingRules={_fetchListShippingRule}>
            <div className="d-flex justify-content-between align-items-center">
                <h1 className="card-title">Setting Shipping Rule</h1>
                
                <div className="actions">
                    <Link to='/shipping-carrier' className="btn btn-link">Shipping carrier management</Link>
                    <Link className="linkDetail" to={`/shipping-rule-new`}><button className="btn btn-primary ml-3">Add new</button></Link>
                </div>
            </div>
            <div className="card SettingShippingRulePage">
                <div className="card-body">
                    <div className="ShippingRuleFilters">
                        <SettingShippingRuleFilters platforms={platforms}/>
                    </div>
                    <div>
                        {error && <div className="text-danger">{error}</div> }
                        <SettingShippingRuleTable loading={loading} limit={limit} page={page} total={total} onChangeSize={_handleSetSize} onChangePage={_handleSetPage} shippingRules={shippingRuleLists} platforms={platforms}/>
                    </div>
                </div>
            </div>
        </SettingShippingRuleProvider>
    )
}

export default SettingShippingRulePage